/*
 * Takes a first name and last name and makes a full name
 * @param {firstName} the first name
 * @param {lastName} the last name
 */
export function fullName(firstName = '', lastName = '') {
  return [firstName, lastName].join(' ')
}

/**
 * Abbreviation of first and last name
 * @param {String} firstName
 * @param {String} lastName
 * @returns {String}
 */
export function abbreviatedName(firstName = '', lastName = '') {
  if (firstName === '' || lastName === '') return ''
  return [firstName.slice(0, 1), lastName].join('. ')
}

/**
 * Creates a possessive name from the last name like K David's
 * @param {String} firstName
 * @param {String} lastName
 * @returns {String}
 */
export function possessiveName(firstName = '', lastName = '') {
  const possessiveLastName = lastName.length === 0 ? '' : `${lastName}'s`
  return `${firstName.slice(0, 1)} ${possessiveLastName}`.trim()
}
